module.exports = __webpack_public_path__ + "img/surgery_z6dmxf_c_scale,w_1400.34933e56.jpg";